import LegalPage from "../components/LegalPage";
import site from "../data/site";

function TermsOfService() {
  const sections = [
    {
      heading: "Introduction",
      body: `These Terms of Service ("Terms") govern your use of the Odinno application, website, and services. By accessing or using our services, you agree to be bound by these Terms.`,
    },
    {
      heading: "Acceptable Use",
      list: [
        "You must use the app only for lawful purposes",
        "You must not misuse, disrupt, or attempt to gain unauthorized access",
        "You must not use the service for spam, fraud, or illegal messaging",
      ],
    },
    {
      heading: "User Accounts & Login",
      body: "You are responsible for maintaining the confidentiality of your login credentials and for all activities that occur under your account.",
    },
    {
      heading: "Privacy & Data Protection",
      body: "Your use of our services is also governed by our Privacy Policy, which explains how we collect, use, and protect your information.",
      link: {
        label: "View the Privacy Policy",
        href: "/privacy-policy",
      },
    },
    {
      heading: "User Data Deletion",
      body: "Users may request deletion of their personal data at any time. Detailed instructions are available on our User Data Deletion page.",
      link: {
        label: "View Data Deletion instructions",
        href: "/data-deletion",
      },
    },
    {
      heading: "Service Availability",
      body: "We do not guarantee uninterrupted service and may modify, suspend, or discontinue any part of the service without prior notice.",
    },
    {
      heading: "Limitation of Liability",
      body: "To the maximum extent permitted by law, Odinno shall not be liable for any indirect, incidental, or consequential damages.",
    },
    {
      heading: "Contact Us",
      body: `If you have any questions regarding these Terms, contact us at: ${site.email}`,
    },
  ];

  return (
    <LegalPage
      title="Terms"
      titleAccent="of Service"
      lead="Please read these terms carefully before using our application or services."
      sections={sections}
    />
  );
}

export default TermsOfService;
